import { ApiRetailerPaymentType, ApiPaymentType } from '@vend/types'

/**
 *  Determines whether a payment type is allowed for an outlet.
 *
 * @param paymentType
 *        The payment type we want to check is available.
 * @param currentOutletId
 *        The id of the outlet to check the payment type availability on.
 *
 * @return true if the payment is enabled for this outlet, false otherwise.
 */
export const isEnabledPaymentTypeForOutlet = (
  paymentType: ApiRetailerPaymentType,
  currentOutletId: string
) => {
  if (paymentType.disabled) {
    return false
  }

  // Enabled if not null and in outlet ids array, otherwise disabled
  if (
    paymentType.outlet_ids &&
    paymentType.outlet_ids.indexOf(currentOutletId) === -1
  ) {
    return false
  }

  // Enabled if outlet id array is falsy and disabled false
  return true
}

export const isIpadOnly = (
  paymentType: ApiPaymentType | undefined
): boolean => {
  if (paymentType && paymentType.platforms) {
    const platforms = paymentType.platforms
    return platforms.includes('IPAD') && platforms.length === 1
  }

  return false
}
